import React, { Fragment } from 'react'
import { Heading } from '@myxplor/ui'
import { FormInput, FormSubmit, FormWrapper } from '@myxplor/forms'
import { ShowHide } from '../../../ui/record-display'
import GovSiteImage from './gov-site-ccs.svg'
import './screenshot.css'

export const validate = ({ organisation_id, provider_registration_id, personnel_id }) => (
  (organisation_id && organisation_id.match(/\d{10}/)) &&
  (provider_registration_id &&
    provider_registration_id.match(/\d{9}/) &&
    provider_registration_id.match(/[a-zA-Z]/)
  ) &&
  (personnel_id && personnel_id.match(/\d{10}/))

)

const ProviderDetailsForm = ({ onSubmit, loading, errors, registration_details }) => (
  <Fragment>
    <Heading small>CCS Provider Registration Details</Heading>

    <p>The below details would have been provided to you when you registered for CCS.
    <br />
      Need help finding the ID numbers? <a href="https://support.ourxplor.com/hc/en-us/articles/360026680631-B2B-Device-Registration-Reactivation" rel="noopener noreferrer" target="_blank">View our Knowledge Base Article</a>
    </p>
    <ShowHide label="help with government numbers">
      <img alt="Sample representation of the government website" className="screenshot" src={GovSiteImage} />
    </ShowHide>

    <FormWrapper
      onSubmit={onSubmit}
      defaultValues={registration_details}
      validate={validate}
      render={({ onChange, values, valid }) => (
        <Fragment>
          <fieldset>
            <FormInput
              name="personnel_id"
              label="Person ID/Management & Control Person ID"
              hint="This is a 10 digit number and normally starts with '01'"
              required
              value={values.personnel_id}
              maxLength={10}
              onChange={onChange}
              loading={loading}
              autoFocus
              htmlInput={{
                pattern: '[0-9]*'
              }}
            />

            <FormInput
              name="provider_registration_id"
              label="CCS Provider ID"
              hint="Your CCS Provider ID will have 9 numbers starting with a '1', and will end with a letter"
              value={values.provider_registration_id}
              maxLength={10}
              required
              loading={loading}
              onChange={onChange}
            />

            <FormInput
              name="organisation_id"
              label="PRODA RA Organisation/Org ID"
              hint="Your Org ID (Organisation ID) is 10 digits long, and only contains numbers"
              maxLength={10}
              value={values.organisation_id}
              required
              loading={loading}
              onChange={onChange}
              htmlInput={{
                pattern: '[0-9]*'
              }}
            />
          </fieldset>

          <FormSubmit
            loading={loading}
            loadingTitle="Migrating to Xplor"
            errors={errors}
            disabled={!valid}
          >Migrate</FormSubmit>
        </Fragment>
      )}
    />

  </Fragment>
)

export default ProviderDetailsForm



// WEBPACK FOOTER //
// ./src/providers-registrations/onboarding/views/provider-details-form.jsx